import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Inject, NgModule } from '@angular/core';
import { TuiTiptapEditorService } from '@taiga-ui/addon-editor/directives';
import { TUI_EDITOR_TOOLBAR_TEXTS, TUI_EDITOR_TABLE_COMMANDS } from '@taiga-ui/addon-editor/tokens';
import { map } from 'rxjs/operators';
import * as i1 from '@taiga-ui/core';
import { TuiHostedDropdownModule, TuiHintModule, TuiButtonModule, TuiDataListModule } from '@taiga-ui/core';
import * as i2 from '@taiga-ui/cdk';
import { TuiLetModule } from '@taiga-ui/cdk';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4 from '@taiga-ui/addon-editor/abstract';
import * as i5 from 'rxjs';

// TODO: change type in v4.0
// eslint-disable-next-line no-restricted-syntax
var TuiTableCommands;
(function (TuiTableCommands) {
    TuiTableCommands[TuiTableCommands["InsertColumnBefore"] = 0] = "InsertColumnBefore";
    TuiTableCommands[TuiTableCommands["InsertColumnAfter"] = 1] = "InsertColumnAfter";
    TuiTableCommands[TuiTableCommands["InsertRowBefore"] = 2] = "InsertRowBefore";
    TuiTableCommands[TuiTableCommands["InsertRowAfter"] = 3] = "InsertRowAfter";
    TuiTableCommands[TuiTableCommands["DeleteColumn"] = 4] = "DeleteColumn";
    TuiTableCommands[TuiTableCommands["DeleteRow"] = 5] = "DeleteRow";
})(TuiTableCommands || (TuiTableCommands = {}));
class TuiTableRowColumnManagerComponent {
    constructor(editor, texts$, tableCommandTexts$) {
        this.editor = editor;
        this.texts$ = texts$;
        this.tableCommandTexts$ = tableCommandTexts$;
        this.commandsRegistry = {
            [TuiTableCommands.InsertColumnAfter]: () => this.editor.addColumnAfter(),
            [TuiTableCommands.InsertColumnBefore]: () => this.editor.addColumnBefore(),
            [TuiTableCommands.InsertRowAfter]: () => this.editor.addRowAfter(),
            [TuiTableCommands.InsertRowBefore]: () => this.editor.addRowBefore(),
            [TuiTableCommands.DeleteColumn]: () => this.editor.deleteColumn(),
            [TuiTableCommands.DeleteRow]: () => this.editor.deleteRow(),
        };
        this.isActive$ = this.editor.isActive$('table');
        this.rowsColumnsManagingText$ = this.texts$.pipe(map(texts => texts.rowsColumnsManaging));
    }
    onTableOption(command) {
        this.commandsRegistry[command]();
    }
}
TuiTableRowColumnManagerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiTableRowColumnManagerComponent, deps: [{ token: TuiTiptapEditorService }, { token: TUI_EDITOR_TOOLBAR_TEXTS }, { token: TUI_EDITOR_TABLE_COMMANDS }], target: i0.ɵɵFactoryTarget.Component });
TuiTableRowColumnManagerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: TuiTableRowColumnManagerComponent, selector: "tui-table-row-column-manager", ngImport: i0, template: "<tui-hosted-dropdown\n    *tuiLet=\"isActive$ | async as active\"\n    #tableCommand\n    [content]=\"tableOptionsDropdown\"\n    [canOpen]=\"!!active\"\n>\n    <button\n        tuiIconButton\n        type=\"button\"\n        size=\"s\"\n        icon=\"tuiIconAddRowLarge\"\n        appearance=\"icon\"\n        tuiHintDirection=\"top-left\"\n        tuiHintDescribe\n        [tuiHint]=\"rowsColumnsManagingText$ | async\"\n        [focusable]=\"tableCommand.open\"\n        [disabled]=\"!active\"\n    ></button>\n</tui-hosted-dropdown>\n\n<ng-template #tableOptionsDropdown>\n    <tui-data-list>\n        <tui-opt-group *ngFor=\"let group of tableCommandTexts$ | async; let i = index\">\n            <!-- TODO: remove \"magic\" numbers i*2+j and make code more readable-->\n            <button\n                *ngFor=\"let item of group; let j = index\"\n                tuiOption\n                (click)=\"onTableOption(i * 2 + j)\"\n            >\n                {{ item }}\n            </button>\n        </tui-opt-group>\n    </tui-data-list>\n</ng-template>\n", components: [{ type: i1.TuiHostedDropdownComponent, selector: "tui-hosted-dropdown", inputs: ["content", "sided", "canOpen", "open"], outputs: ["openChange", "focusedChange"] }, { type: i1.TuiButtonComponent, selector: "button[tuiButton], button[tuiIconButton], a[tuiButton], a[tuiIconButton]", inputs: ["appearance", "disabled", "icon", "iconRight", "shape", "showLoader", "size"] }, { type: i1.TuiDataListComponent, selector: "tui-data-list", inputs: ["role", "emptyContent", "size"] }, { type: i1.TuiOptionComponent, selector: "button[tuiOption], a[tuiOption]", inputs: ["size", "role", "disabled", "value"] }], directives: [{ type: i2.TuiLetDirective, selector: "[tuiLet]", inputs: ["tuiLet"] }, { type: i1.TuiHintDescribeDirective, selector: "[tuiHintDescribe]", inputs: ["tuiHintDescribe"] }, { type: i1.TuiHintDirective, selector: "[tuiHint]:not(ng-container)", inputs: ["tuiHint", "tuiHintContext", "tuiHintAppearance"] }, { type: i1.TuiHintDriverDirective, selector: "[tuiHint]" }, { type: i1.TuiHintHoverDirective, selector: "[tuiHint]:not(ng-container)", inputs: ["tuiHintShowDelay", "tuiHintHideDelay"], exportAs: ["tuiHintHover"] }, { type: i1.TuiHintPositionDirective, selector: "[tuiHint]:not([tuiHintCustomPosition])", inputs: ["tuiHintDirection"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1.TuiOptGroupDirective, selector: "tui-opt-group", inputs: ["label"] }], pipes: { "async": i3.AsyncPipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiTableRowColumnManagerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'tui-table-row-column-manager',
                    templateUrl: './table-row-column-manager.template.html',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i4.AbstractTuiEditor, decorators: [{
                    type: Inject,
                    args: [TuiTiptapEditorService]
                }] }, { type: i5.Observable, decorators: [{
                    type: Inject,
                    args: [TUI_EDITOR_TOOLBAR_TEXTS]
                }] }, { type: i5.Observable, decorators: [{
                    type: Inject,
                    args: [TUI_EDITOR_TABLE_COMMANDS]
                }] }]; } });

class TuiTableRowColumnManagerModule {
}
TuiTableRowColumnManagerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiTableRowColumnManagerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TuiTableRowColumnManagerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiTableRowColumnManagerModule, declarations: [TuiTableRowColumnManagerComponent], imports: [CommonModule,
        TuiHostedDropdownModule,
        TuiHintModule,
        TuiButtonModule,
        TuiDataListModule,
        TuiLetModule], exports: [TuiTableRowColumnManagerComponent] });
TuiTableRowColumnManagerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiTableRowColumnManagerModule, imports: [[
            CommonModule,
            TuiHostedDropdownModule,
            TuiHintModule,
            TuiButtonModule,
            TuiDataListModule,
            TuiLetModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiTableRowColumnManagerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        TuiHostedDropdownModule,
                        TuiHintModule,
                        TuiButtonModule,
                        TuiDataListModule,
                        TuiLetModule,
                    ],
                    declarations: [TuiTableRowColumnManagerComponent],
                    exports: [TuiTableRowColumnManagerComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TuiTableCommands, TuiTableRowColumnManagerComponent, TuiTableRowColumnManagerModule };
